import React, { useContext, useEffect, lazy, useState } from "react";
import { useLocation } from "react-router-dom";
import { RouteChangeScrollToTop } from "manifest-core/utils/scrollToTop";
import styled from "styled-components";
import Authentication from "../utils/authentication";

import NonAuthRoutes from "./NonAuthRoutes";
import { HeaderHeight } from "../components/HeaderComponent";
import { AppContext } from "../context/App/appProvider";
import DeveloperTools from "../components/DeveloperTools";
import { FullScreenLoader } from "../components/FullScreenLoader";

const AuthRoutes = lazy(() => import("./AuthRoutes"));

const StyledApp = styled.div`
  padding-top: ${HeaderHeight}px;
`;

export default function AppRoutes() {
  const { updateGlobalCSSVar, showFullScreenLoader } = useContext(AppContext);
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(Authentication.verify());

  useEffect(() => {
    updateGlobalCSSVar("desktopWidth", "1320px");
  }, []);

  useEffect(() => {
    setIsAuthenticated(Authentication.verify());
  }, [location.pathname]);

  return (
    <StyledApp id="app">
      <FullScreenLoader show={showFullScreenLoader} />
      <RouteChangeScrollToTop />
      <DeveloperTools />
      {isAuthenticated ? <AuthRoutes /> : <NonAuthRoutes />}
    </StyledApp>
  );
}
